/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MultiBarChartData
 */
export interface MultiBarChartData {
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiBarChartData
     */
    barTitles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MultiBarChartData
     */
    barValues: Array<string>;
}

/**
 * Check if a given object implements the MultiBarChartData interface.
 */
export function instanceOfMultiBarChartData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "barTitles" in value;
    isInstance = isInstance && "barValues" in value;

    return isInstance;
}

export function MultiBarChartDataFromJSON(json: any): MultiBarChartData {
    return MultiBarChartDataFromJSONTyped(json, false);
}

export function MultiBarChartDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultiBarChartData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barTitles': json['barTitles'],
        'barValues': json['barValues'],
    };
}

export function MultiBarChartDataToJSON(value?: MultiBarChartData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barTitles': value.barTitles,
        'barValues': value.barValues,
    };
}

